import { render, staticRenderFns } from "./YunCang.vue?vue&type=template&id=5121be7a&"
import script from "./YunCang.vue?vue&type=script&lang=js&"
export * from "./YunCang.vue?vue&type=script&lang=js&"
import style0 from "./YunCang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports